import React from 'react';
import { Crown } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export function SubscriptionBadge() {
  const { subscription } = useAuth();

  if (!subscription) {
    return (
      <span className="text-xs font-medium bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
        Free Plan
      </span>
    );
  }

  if (subscription.status === 'active' || subscription.status === 'trialing') {
    return (
      <span className="text-xs font-medium bg-primary/10 text-primary px-2 py-1 rounded-full flex items-center space-x-1">
        <Crown className="w-3 h-3" />
        <span>{subscription.product.name}</span>
      </span>
    );
  }

  return (
    <span className="text-xs font-medium bg-red-100 text-red-600 px-2 py-1 rounded-full">
      Inactive
    </span>
  );
}